export default {
    DEV_ENV: 'http://localhost:3000',
    TEST_ENV: '/api',
    PROD_ENV: 'http://www.ulog.top/api'
    // PROD_ENV: 'http://139.9.182.254:3000'
}